
export default function getUsername(userMail) {
  return userMail ? userMail.replace(/@.*$/,'') : ''
}